export default (function (array) {
  return array[array.length - 1];
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-blueprint/~/redux-actions/es/utils/getLastElement.js
// module id = 1448
// module chunks = 1